/* eslint-disable no-unused-vars */
import React, { FC } from 'react';
import { ListGroup } from 'react-bootstrap';
import useReorder from '../../../hooks/useReorder/useReorder';

import { BlockType } from '../../../store/landscapeAPI/block/dto/block-type';
import { SortableImageBlockItem, SortableTextBlockItem } from '../../atoms';
import { BlockItem } from '../../atoms/SortableImageBlockItem/SortableImageBlockItem';

interface SortableBlockListProps {
  blockItems: BlockItem[];
  setBlockItems: (items: BlockItem[], from: number, to: number) => void;
  changeOrderEnabled: boolean;
  handleDelete: (id: string) => void;
  handleEdit: (id: string, type: BlockType) => void;
}

const SortableBlockList: FC<SortableBlockListProps> = ({
  blockItems,
  setBlockItems,
  changeOrderEnabled,
  handleDelete,
  handleEdit,
}) => {
  const [litems, moveItem] = useReorder<BlockItem>(
    blockItems,
    setBlockItems,
    true
  );

  return (
    <>
      <ListGroup>
        {litems.length === 0 && <p>Nothing to show.</p>}
        {litems.length > 0 &&
          litems.map((item, index) => {
            if (item.type === BlockType.ImageBlock) {
              return (
                <SortableImageBlockItem
                  id={item.id}
                  key={item.id}
                  blockItems={litems}
                  blockItemsLength={litems.length}
                  blockItemIndex={index}
                  moveListItem={moveItem}
                  changeOrderEnabled={changeOrderEnabled}
                  blockItem={item}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              );
            } else {
              return (
                <SortableTextBlockItem
                  id={item.id}
                  key={item.id}
                  blockItems={litems}
                  blockItemsLength={litems.length}
                  blockItemIndex={index}
                  moveListItem={moveItem}
                  changeOrderEnabled={changeOrderEnabled}
                  blockItem={item}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              );
            }
          })}
      </ListGroup>
    </>
  );
};

export default SortableBlockList;
